import { useVirtualWidgets } from './hooks/useVirtualWidgets';

// This component ensures that virtual widgets remain mounted to prevent state loss when the component is unmounted.
// read more about it here: https://www.algolia.com/doc/guides/building-search-ui/widgets/show-and-hide-widgets/react/#keep-the-widget-mounted-but-hidden
export const VirtualWidgets: React.FC = () => {
	useVirtualWidgets();

	return null;
};
